import { Box, Text } from 'theme-ui'
import styles from './styles'

const Closed = ({ layout }: Pages.Closed) => {
  return (
    <Box sx={styles.container}>
      <Text sx={styles.heading}>{layout.message}</Text>
    </Box>
  )
}

export default Closed
